import { useStore } from 'effector-react'
import * as React from 'react'

import { $reject, mounted, rejectTransactionRequest, unmounted } from './model'

export const useReject = () => {
  const reject = useStore($reject)
  const isLoading = useStore(rejectTransactionRequest.pending)

  React.useEffect(() => {
    mounted()
    return () => unmounted()
  }, [])

  return { reject, isLoading }
}
